// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'dataviz-funnel-solid';

export const Component = () => (
  <path d='M21.662 6.445 16 12v4.5c0 .813-.447 1.055-1 1.5-.553.445-4.447 4-5 4s-1-.448-1-1v-9L3.338 6.445A1.481 1.481 0 0 1 3 5.507C3 4.732 3.609 4 4.502 4h15.995A1.5 1.5 0 0 1 22 5.507c0 .322-.105.651-.338.938z' />
);

export const viewBox = '0 0 25 25';
